export default __webpack_public_path__ + "static/media/soulcorruption.433238cd.png";